import type { FC } from 'react';
import IconMdi from '@components/IconMdi';
import type { ElementSize } from '@components/types';
import { mdiClose } from '@mdi/js';
import { cva } from 'class-variance-authority';

const logo = {
  artificial: '/assets/Artificial_Logo_Black.svg',
  artificialCollapsed: '/assets/artificial-logo.svg',
  ppl: {
    black: '/assets/PPL_Logo_Black.svg',
    white: '/assets/PPL_Logo_White.svg',
  },
};

const logoClasses = cva([], {
  variants: {
    size: {
      sm: 'h-[21px]',
      md: 'h-[27px]',
      lg: 'h-[33px]',
    },
    logoColor: {
      white: 'filter invert',
      black: null,
    },
  },
});

const classes = cva(['flex', 'items-center'], {
  variants: {
    size: {
      sm: 'gap-3',
      md: 'gap-3',
      lg: 'gap-5',
    },
    logoColor: {
      black: 'text-inherit',
      white: 'text-white',
    },
  },
});

interface LogoCollaborationProps {
  logoColor?: 'white' | 'black';
  size?: ElementSize;
  isCollapsed?: boolean;
}

export const LogoCollaboration: FC<LogoCollaborationProps> = ({
  logoColor = 'black',
  size = 'md',
  isCollapsed = false,
}) => (
  <div className={classes({ size, logoColor })}>
    <img
      src={isCollapsed ? logo.artificialCollapsed : logo.artificial}
      className={logoClasses({ size, logoColor })}
      alt="Artificial Logo"
    />
    {/* The full lockup is three marks wide and cannot fit the collapsed sidebar, so the
        cross and the PPL mark drop out and only the compact Artificial mark remains. */}
    {!isCollapsed && (
      <>
        <IconMdi path={mdiClose} size={0.65} />
        <img src={logo.ppl[logoColor]} className={logoClasses({ size })} alt="PPL Logo" />
      </>
    )}
  </div>
);
